<template>
  <div
    class="filter__item"
    :class="{
      'filter__item--hover': hover,
      'filter__item--light': light,
      'filter__item--noRemove': disabled
    }"
  >
    <slot />
    <button
      v-if="!disabled"
      class="filter__item__remove"
      @click="$emit('remove')"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
      <i class="fas fa-times" />
    </button>
  </div>
</template>
<script setup>
import { ref } from 'vue'
const emit = defineEmits(['remove'])
const props = defineProps({
  light: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
const hover = ref(false)
</script>
<style lang="scss" scoped>
.filter__item {
  display: flex;
  align-items: center;
  background: $blue-80;
  position: relative;
  width: fit-content;
  font-size: 12px;
  border-radius: 5px;
  padding: 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  white-space: break-spaces;
  padding-right: 23px;
  color: $white;
  &--hover {
    background: $blue-100;
    .filter__item__remove {
      background: $blue-100;
    }
  }
  &--noRemove {
    padding-right: 5px;
    cursor: not-allowed;
  }
  &__name {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100px;
    white-space: nowrap;
  }
  &__remove {
    display: flex;
    justify-content: center;
    align-items: baseline;
    position: absolute;
    height: fit-content;
    right: 0;
    top: 0;
    border: none;
    font-weight: 700;
    padding: 5px;
    cursor: pointer;
    color: $white;
    background: $blue-80;
  }
  &--light {
    background: $blue-10;
    color: $black-100;
    border: 1px solid $blue-80;
    .filter__item--hover {
      background: $blue-10;
      color: $black-100;
    }
    .filter__item__remove {
      border-radius: var(--border-radius);
      background: $blue-10;
      color: $black-50;
    }
  }
}
</style>
